import { useEffect, useState } from "react";
import { getApplicationSettings } from "../../services/apiManager/apiRequests";
import apiConfig from "../../services/apiManager/apiConfig";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";

export const useAppSettings = () => {
  const [appSettings, setAppSettings] = useState({});
  const triggerAppSetting = async () => {
    try {
      const resp = await getApplicationSettings(apiConfig.appSettings);
      setAppSettings(resp?.appSettings);
    } catch (err) {
      enqueueSnackbar("Error getting app settings", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
    }
  };
  useEffect(() => {
    triggerAppSetting();

    const maintinanceTrigger = setInterval(
      () => {
        triggerAppSetting();
      },
      1000 * 60 * 60,
    );

    return () => {
      clearInterval(maintinanceTrigger);
    };
  }, []);

  return { appSettings, setAppSettings };
};
